<template>
    <div class="p-3">
        <select-modal 
            placeholder-button="Selecionar executoras e cooperadas" 
            :modal-fields="colunasModal" 
            :fields="fields.filter(el => el.key != 'acoes' && el.key != 'logoDaEmpresa')" 
            :fetch-method="fetchMethod"
            term-initial="nomeFantasia"
            :values="empresas"
            slot-image="logoDaEmpresa"
            slot-tabela-image="logo"
            @update="atualizarEmpresas"
            modalTitle="EMPRESAS"
            :controles="!aprovada"
            hide-selected
            @hidden="fecharModal"
            
            :esconder-inserir="!permissao.u || telaCooperada"

            ref="empresa"
        >
            <template #append-button>
                <div>
                    <b-button class="ml-2" v-if="podeEditarProponente && permissao.u" @click="selecionarProponente">
                        <i class="fas fa-plus"></i>
                        <span class="ml-2">Selecionar proponente</span>
                    </b-button>
                </div>
            </template>
            <template #btn-remove="data">
                <div>
                    <b-button v-if="!aprovada && data.item.tipo != 'ExecutoraCriadora' && data.item.tipo != 'Proponente' && data.item.id != empresaSelecionada.id && permissao.d && !telaCooperada" variant="flat-danger" class="mr-2"  @click="excluirEmpresa(data.item)"><i class="fas fa-trash"></i></b-button>
                </div>
            </template>
        </select-modal>
    </div>
</template>
<script>

import SelectModal from "@/components/modal/SelectModal";
import EmpresasService from "@/common/services/empresas/empresas.service";
import PropostaService from "@/common/services/proposta/proposta.service";
import { AlertasMixin } from "@/common/mixins/AlertasMixin";
import { FormMixin } from "@/common/mixins/FormMixin";
//import cloneDeep from "lodash/cloneDeep";
import { START_LOADING, STOP_LOADING } from "@/store/Store";
import helpers from "@/common/utils/helpers";

export default {
    name: "PropostaEmpresas",
    mixins: [AlertasMixin, FormMixin],
    emits: ["update"],
    props: {
        propostaId: {
            required: true
        },
        propostaOriginalId: {
            type: String,
            required: true
        },
        value: {
            type: Array
        },
        aprovada: {
            type: Boolean,
            default: false
        },
    },
    components: {
        SelectModal
    },
    data: () =>({
        fields : [
            
            { key: "acoes", label: "Ações", tdClass: "acoes", },
            { key: "logoDaEmpresa", label:""},
            { key: "logo", label:""},
            { key: "nomeFantasia", label: "Empresa", },            
            { key: "tipo", label: "Tipo",
                formatter: (value) => {
                    if (value) return helpers.getEnum(value).text;
                },
            },
            { key: "custosProprios ", label: "Custos próprios(R$)",
                formatter: (v) => {
                    if(v != null) return helpers.formatarValor(v);
                }
            }, 
            { key: "repasseExecutoras ", label: "Repasse executoras(R$)",
                formatter: (v) => {
                    if(v != null) return helpers.formatarValor(v);
                }
            }, 
            { key: "valorInvestido", label: "Valor do investimento(R$)",
                formatter: (v) => {
                    if(v != null) return helpers.formatarValor(v);
                }
            }, 
            { key: "remove", label: "Ações", },  
        ],

        colunasModal : [
            
            { key: "acoes", label: "Ações", tdClass: "acoes", },
            { key: "nomeFantasia", label: "Empresa", },            
            { key: "tipo", label: "Tipo",
                formatter: (value) => {
                    if (value) return helpers.getEnum(value).text;
                },
            },
        ],
        empresas : [],
        modalProponente : false,
    }),
    methods:{
        fetchMethod: function(){
            return new Promise((resolve, reject) => { 
                if(this.modalProponente){
                    EmpresasService.buscarTipo('Proponente').then(res => {
                        resolve({data : {
                            data : res.data.data.filter(
                                el => 
                                    this.empresas.find(el2 => el2.empresaId == el.id) == undefined
                                ).map(el => {
                                    el.nomeFantasia = el.nomeFantasia || el.razaoSocial;
                                    return el;
                                })
                        }});
                    }).catch(err => {
                        reject(err);
                    });
                }else{
                    EmpresasService.buscarTipo('').then(res => {
                        resolve({data : {
                            data : res.data.data.filter(
                                el => 
                                    el.id != this.empresaSelecionada.id &&
                                    //el.tipo == this.tipoEmpresa &&
                                    this.empresas.find(el2 => el2.empresaId == el.id) == undefined
                                ).map(el => {
                                    el.tipo = el.tipo == 'Proponente' ? 'Cooperada' : el.tipo;
                                    el.nomeFantasia = el.nomeFantasia || el.razaoSocial;
                                    return el;
                                })
                        }});
                    }).catch(err => {
                        reject(err);
                    });
                }
            });
        },
        fecharModal: function(){
            this.modalProponente = false;
        },
        selecionarProponente: function(){
            this.modalProponente = true;
            this.$refs.empresa.openModal();
        },
        atualizarProponente : function(empresa){
            let form = {
                propostaId: this.propostaId,
                empresaProponenteId: empresa.item.id,
            };

            PropostaService.atualizarProponente(form).then(() => {
                this.alertaSucesso("Proponente atualizado com sucesso!");              
            }).catch(() => {                
                this.alertaErro("Erro ao atualizar proponente!");
            }).finally(() => {
                this.modalProponente = false;
                this.$refs.empresa.fecharModal();
                this.buscarEmpresas();
            });
        },
        atualizarEmpresas: function(company){
            if(this.modalProponente){
                this.atualizarProponente(company);
                return;
            }

            let form = {
                propostaId: this.propostaOriginalId,
                empresasId: [
                    company.item.id
                ],
            };

            PropostaService.adicionarEmpresa(form, company.item.tipo == 'Executora' ? 'executoras' : 'cooperadas').then(() => {
                this.$bvToast.toast("Empresas associada com sucesso!", {
                    title: "Sucesso",
                    toaster: 'b-toaster-bottom-right',
                    solid: true,
                    appendToast: true,
                    variant: 'success'
                });
                this.buscarEmpresas().then(() => {
                    this.$refs['empresa'].recarregar();
                });              
            }).catch(() => {      
                this.$bvToast.toast("Erro ao associar empresa", {
                title: "Erro",
                toaster: 'b-toaster-bottom-right',
                solid: true,
                appendToast: true,
                variant: 'error'
                });
            });
        },
        excluirEmpresa : function(empresa){
            let form = {
                propostaId: this.propostaOriginalId,
                empresasId: [
                    empresa.id
                ],
            };
            this.confirmar("Deseja remover essa empresa da proposta?").then(confirmado => {
                if(!confirmado) return;

                
                PropostaService.removerEmpresa(form,empresa.tipo == 'Executora' ? 'executoras' : 'cooperadas').then(() => {
                    this.alertaSucesso("Empresa removida com sucesso!");
                    this.buscarEmpresas();                
                }).catch(() => {      
                    this.alertaErro("Erro ao remover empresa");
                });

            })
        },

        buscarEmpresas : function(){
            return new Promise((resolve) => {
                this.$store.dispatch(START_LOADING);
                this.empresas = [];
                PropostaService.buscarEmpresas(this.propostaOriginalId).then(response => {
                    this.empresas = response.data.data;
                    resolve();
                }).finally(() => {
                    this.$store.dispatch(STOP_LOADING);
                });
            });
        },
        montar(){
            this.buscarEmpresas();
        }
    },
    mounted(){
    },
    computed: {
        permissao() {
            return this.$store.getters['app/retornaPermissao']('PropostaEmpresas');
        },
        empresaSelecionada() {
            return this.$store.state.app.selectedCompanyObj;
        },
        tipoEmpresa : function(){
            switch(this.$route.name){
                case "proposta-executora-detalhamento":
                    return "Executora";                    
                case "proposta-proponente-detalhamento":
                    return "Proponente";
                default : 
                    return "";
                
            }
        },
        tipoEdicaoEmpresa : function(){
            switch(this.$route.name){
                case "proposta-executora-detalhamento":
                    return "Executora";                    
                case "proposta-proponente-detalhamento":
                    return "Cooperada";
                default : 
                    return "";
                
            }
        },
        tipoEndpoint : function(){
            switch(this.$route.name){
                case "proposta-executora-detalhamento":
                    return "executoras";
                case "proposta-proponente-detalhamento":
                    return "cooperadas";
                default : 
                    return "";
                
            }
        }, 
        podeEditarProponente : function(){
            return this.$route.name == "proposta-executora-detalhamento";
        },
        telaCooperada : function(){
            return this.$route.name == "proposta-proponente-cooperada-detalhamento";
        }
    }
}
</script>
<style lang="">
    
</style>